import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Help = function Help(props) {
  useDeprecatedComponentWarning({
    component: 'Help'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.387c-.645 0-1.129.524-1.129 1.13 0 .644.484 1.128 1.129 1.128.605 0 1.129-.484 1.129-1.129 0-.605-.524-1.129-1.129-1.129zm.282-.968a.466.466 0 00.484-.484c0-1.733 3.145-1.612 3.145-4.314 0-2.056-1.854-3.266-3.951-3.266-1.815 0-2.823.726-3.67 1.814-.161.242-.12.525.121.686l.524.403c.202.121.484.08.646-.12.604-.767 1.21-1.17 2.379-1.17 1.613 0 2.338.847 2.338 1.653 0 1.734-3.145 1.492-3.145 4.314a.49.49 0 00.484.484h.645zM12 3.29c4.758 0 8.71 3.912 8.71 8.71A8.7 8.7 0 0112 20.71 8.673 8.673 0 013.29 12 8.699 8.699 0 0112 3.29zM12 2C6.476 2 2 6.516 2 12c0 5.524 4.476 10 10 10 5.484 0 10-4.476 10-10 0-5.484-4.516-10-10-10z"
  }));
};

Help.displayName = 'Help';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Help.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Help;